import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { ExpandedListViewItemDefinition } from '../../../core/model/expanded-list-view-item';
import { CompanyService } from '../../../rent/service/data/company.service';
import { PropertyService } from '../../../rent/service/data/property.service';
import { LocalDate } from '../../../core/model/local-date';
import { ReportService } from '../../service/data/report.service';
import { canSubmitReportForm } from '../../utility/report-form-validation';

@Component({
    selector: 'app-rental-object-rent-loss',
    templateUrl: './rental-object-rent-loss.component.html',
    styleUrls: ['./rental-object-rent-loss.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectRentLossReportComponent implements OnInit {
  constructor(
    private _cdf: ColumnDefinitionFactory,
    private _companyService: CompanyService,
    private _propertyService: PropertyService,
    private _dataService: ReportService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    const today = new Date();
    this.from = LocalDate.fromDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
    this.to = LocalDate.fromDate(new Date(this.from.toDate().getFullYear(), this.from.toDate().getMonth() + 1, 0));

    this.form = fb.group({
      company: fcf.create('COMMON.COMPANY', ''),
      property: fcf.create('COMMON.PROPERTY', ''),
      from: fb.group({}),
      to: fb.group({}),
    });

    this.columnDefinitions = [
      this._cdf.create('COMMON.SQUARE_METER', 'surface'),
      this._cdf.createMoney('COMMON.RENT_LOSS', 'totalRentLoss'),
    ];
  }

  columnDefinitions: ColumnDefinition[] = [];
  companies: { name: string; value: string }[];
  realEstateProperties: { name: string; value: string }[];
  dataContext: ExpandedListViewItemDefinition[] = [];
  form: FormGroup;
  from: LocalDate;
  to: LocalDate;
  protected expandAllRows: boolean = false;

  ngOnInit() {
    this._companyService.getList().subscribe(data => {
      this.companies = [{ name: 'ALL_TEXT', value: '' }];
      data.forEach(item => {
        this.companies.push({ name: item.toString(), value: item.id });
      });

      if (this.companies.length >= 2) {
        this.form.controls['company'].setValue(this.companies[1].value);
      }
    });

    this._propertyService.getList().subscribe(data => {
      this.realEstateProperties = [{ name: 'ALL_TEXT', value: '' }];
      data.forEach(item => {
        this.realEstateProperties.push({ name: item.toString(), value: item.id });
      });
    });
  }

  onPrintPages() {
    if (!canSubmitReportForm(this.form)) return;
    window.print();
  }

  onSubmit() {
    if (!canSubmitReportForm(this.form)) return;
    this.expandAllRows = false;

    this._dataService.getRentalObjectRentLoss(this.form.value).subscribe(data => {
      this.dataContext = data
        ? data.map(overview => {
            const model = new ExpandedListViewItemDefinition();
            model.caption = overview.rentalObjectName;
            model.columnDefinitions = [
              this._cdf.createDate('VACANT_RENTAL_OBJECT_LIST.VACANT_PERIOD_FROM', 'fromDate'),
              this._cdf.createDate('VACANT_RENTAL_OBJECT_LIST.VACANT_PERIOD_TO', 'toDate'),
              this._cdf.createMoney('COMMON.RENT_LOSS', 'rentLossForPeriod'),
            ];
            model.dataContext = overview;
            model.icon = 'account-statement';
            model.itemsSource = overview.vacancyPeriods.map(x => {
              return {
                fromDate: LocalDate.fromDate(x.fromDate),
                toDate: LocalDate.fromDate(x.toDate),
                rentLossForPeriod: x.rentLossForPeriod,
              };
            });
            return model;
          })
        : [];
    });
  }
  toggleExpandAllRows() {
    this.expandAllRows = !this.expandAllRows;
  }
}
